import { fromJS, List } from 'immutable';

import { SET_UPLOAD, TOGGLE_FAVORITE, TOGGLE_SAVED } from 'redux/reducers/photos';
import { LOGOUT } from 'redux/reducers/user';

export const SAVE = 'kroost/orders/SAVE';
export const SET_ORDERS = 'kroost/orders/SET_ORDERS';
export const GET_ORDERS = 'kroost/orders/GET_ORDERS';
export const CREATE_ORDER = 'kroost/orders/CREATE_ORDER';
export const RENAME_ID = 'kroost/orders/RENAME_ID';
export const ADD_ORDER = 'kroost/orders/ADD_ORDER';
export const SET_OPTION = 'kroost/orders/SET_OPTION';
export const START_PAYMENT = 'kroost/orders/START_PAYMENT';
export const START_PAYMENT_RENEW = 'kroost/orders/START_PAYMENT_RENEW';
export const UPDATE_TRANSFORM = 'kroost/orders/UPDATE_TRANSFORM';
export const UPDATE_TEXT = 'kroost/orders/UPDATE_TEXT';
export const PICK_MOMENT = 'kroost/orders/PICK_MOMENT';
export const FINISH = 'kroost/orders/FINISH';
export const ENABLE_EXTRA_SPREAD = 'kroost/orders/ENABLE_EXTRA_SPREAD';
export const DISABLE_EXTRA_SPREAD = 'kroost/orders/DISABLE_EXTRA_SPREAD';

// Initial routing state
const initialState = fromJS({});

const initialTransform = fromJS({
  width: 1,
  x: 0,
  y: 0,
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_ORDERS:
      return state.merge(fromJS(action.orders));
    case ADD_ORDER:
      return state.set(action.id, fromJS(action.order));
    case RENAME_ID: {
      const order = state.get(action.oldId);

      if (!order) {
        return state;
      }

      return state.delete(action.oldId).set(action.newId, order.delete('local'));
    }
    case SET_OPTION: {
      let path = [action.orderId, action.option];
      if (Array.isArray(action.option)) {
        path = [action.orderId, ...action.option];
      }
      return state.setIn(path, action.value);
    }

    /**
     * Photo edits
     */
    case TOGGLE_SAVED:
    case TOGGLE_FAVORITE: {
      const path =
        action.type === TOGGLE_SAVED ? [action.orderId, 'saved'] : [action.orderId, 'favorites', action.currentSpread];
      return state.updateIn(path, List(), saved => {
        const index = saved.findIndex(savedSimpleId => savedSimpleId === action.simpleId);
        return index === -1 ? saved.push(action.simpleId) : saved.delete(index);
      });
    }
    case SET_UPLOAD:
      return state.setIn([action.orderId, 'uploads', action.simpleId], fromJS(action.upload));

    /**
     * Moment edits
     */
    case PICK_MOMENT:
      return state.setIn(
        [action.orderId, 'picked', action.momentId],
        fromJS({
          simpleId: action.simpleId,
          transform: initialTransform,
        })
      );
    case UPDATE_TRANSFORM:
      return state.mergeIn([action.orderId, 'picked', action.momentId, 'transform'], fromJS(action.transform));
    case UPDATE_TEXT:
      if (action.text === null) {
        return state.deleteIn([action.orderId, 'picked', action.momentId]);
      } else {
        return state.setIn([action.orderId, 'picked', action.momentId, 'text'], action.text);
      }

    /**
     * Extra spreads
     */
    case ENABLE_EXTRA_SPREAD:
      return state.updateIn([action.orderId, 'extra_spreads'], List(), extras => {
        return extras.indexOf(action.spreadId) === -1 ? extras.push(action.spreadId) : extras;
      });
    case DISABLE_EXTRA_SPREAD:
      return state.updateIn([action.orderId, 'extra_spreads'], List(), extras => {
        return extras.filter(spreadId => spreadId !== action.spreadId);
      });
    case LOGOUT:
      return fromJS({});
    default:
      return state;
  }
}

export function setAll(orders) {
  return {
    type: SET_ORDERS,
    orders,
  };
}

export function add(id, order) {
  return {
    type: ADD_ORDER,
    id,
    order,
  };
}

export function getOrders() {
  return {
    type: GET_ORDERS,
  };
}

export function createOrder({
  book = null,
  name = '',
  birthday = '',
  onlyWhenEmpty = false,
  redirect = false,
  pushHistory = true,
}) {
  return {
    type: CREATE_ORDER,
    book,
    name,
    birthday,
    onlyWhenEmpty,
    redirect,
    pushHistory,
  };
}

export function renameId(oldId, newId) {
  return {
    type: RENAME_ID,
    oldId,
    newId,
  };
}

export function setOption(orderId, option, value, options = {}) {
  return {
    type: SET_OPTION,
    orderId,
    option,
    value,
    options,
  };
}

export function save() {
  return {
    type: SAVE,
  };
}

export function startPayment(orderId) {
  return {
    type: START_PAYMENT,
    orderId,
  };
}

export function finish(orderId) {
  return {
    type: FINISH,
    orderId,
  };
}

export function startPaymentRenew(orderId) {
  return {
    type: START_PAYMENT_RENEW,
    orderId,
  };
}

export function pickMoment(orderId, momentId, simpleId) {
  return {
    type: PICK_MOMENT,
    orderId,
    momentId,
    simpleId,
  };
}

export function updateTransform(orderId, momentId, transform) {
  return {
    type: UPDATE_TRANSFORM,
    orderId,
    momentId,
    transform,
  };
}

export function updateText(orderId, momentId, text) {
  return {
    type: UPDATE_TEXT,
    orderId,
    momentId,
    text,
  };
}

export function enableExtraSpread(orderId, spreadId) {
  return {
    type: ENABLE_EXTRA_SPREAD,
    orderId,
    spreadId,
  };
}

export function disableExtraSpread(orderId, spreadId) {
  return {
    type: DISABLE_EXTRA_SPREAD,
    orderId,
    spreadId,
  };
}



// WEBPACK FOOTER //
// ./app/redux/reducers/orders.js